import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Courses from "./pages/Courses";
import Faculty from "./pages/Faculty";
import Facilities from "./pages/Facilities";
import Gallery from "./pages/Gallery";
import Admission from "./pages/Admission";
import Contact from "./pages/Contact";
import Notices from "./pages/Notices";
import Vacancies from "./pages/Vacancies";
import Support from "./pages/Support";
import Resources from "./pages/Resources";
import Testimonials from "./pages/Testimonials";
import { ApplyProvider } from "./components/ApplyContext";
import ApplyFloatingButton from "./components/ApplyFloatingButton";

function App() {
  return (
    <div className="App min-h-screen bg-brand-ivory text-brand-ink">
      <BrowserRouter>
        <ApplyProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/faculty" element={<Faculty />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/admission" element={<Admission />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/notices" element={<Notices />} />
              <Route path="/vacancies" element={<Vacancies />} />
              <Route path="/support" element={<Support />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/testimonials" element={<Testimonials />} />
            </Route>
          </Routes>
          <ApplyFloatingButton />
        </ApplyProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
